import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { OMNIA_PROJECT } from "@/data";

export const OmniaProjectCard = () => (
    <motion.article
        data-testid="project-omnia"
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="group grid items-center gap-8 border-b border-[#121211]/10 py-12 lg:grid-cols-12 lg:py-16"
    >
        <div data-testid="omnia-project-image-column" className="lg:col-span-7">
            <div data-testid="omnia-project-photo-frame" className="relative aspect-[16/10] overflow-hidden">
                <img
                    src={OMNIA_PROJECT.image}
                    alt="OMNIA Wellness Center reception interior"
                    loading="lazy"
                    data-testid="omnia-project-image"
                    className="h-full w-full object-contain"
                />
            </div>
        </div>
        <div data-testid="omnia-project-description-column" className="min-w-0 lg:col-span-5">
            <h3 data-testid="omnia-project-title" className="font-display text-3xl font-light leading-tight text-[#121211] sm:text-4xl">
                {OMNIA_PROJECT.title}
            </h3>
            <p data-testid="omnia-project-category" className="mt-3 font-mono2 text-[10px] uppercase leading-relaxed tracking-[0.3em] text-[#6B6862]">
                {OMNIA_PROJECT.category}
            </p>
            <p data-testid="omnia-project-description" className="mt-3 text-sm font-light leading-relaxed text-[#121211]/70">
                {OMNIA_PROJECT.description}
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
                <a
                    data-testid="omnia-project-website-link"
                    data-interactive
                    href={OMNIA_PROJECT.websiteUrl}
                    target="_self"
                    className="project-cta inline-flex items-center gap-3 rounded-full border border-[#121211] bg-[#121211] px-5 py-3 font-mono2 text-[10px] uppercase tracking-[0.16em] text-[#FBF9F5]"
                >
                    VISIT WEBSITE <ArrowUpRight aria-hidden="true" className="h-4 w-4 shrink-0" />
                </a>
                <a
                    data-testid="omnia-project-tour-link"
                    data-interactive
                    href={OMNIA_PROJECT.tourUrl}
                    target="_self"
                    className="project-cta inline-flex items-center gap-3 rounded-full border border-[#121211]/30 px-5 py-3 font-mono2 text-[10px] uppercase tracking-[0.16em] text-[#121211]"
                >
                    EXPLORE 360° TOUR <ArrowUpRight aria-hidden="true" className="h-4 w-4 shrink-0" />
                </a>
            </div>
        </div>
    </motion.article>
);